/* global Search */

if (document.querySelector(".fbjs-search--news-landing")) {
    let hasActiveFilters;
    window.searchNewsLanding = new Search.default({
        url: "https://dxp-uk-search.funnelback.squiz.cloud/s/search.json",
        collections: ["wood~sp-push-data"],
        additionalFBparams: {
            profile: "_default",
            // gscope1: 'newsLanding', //we cant use it
            "f.pageType|pageType": "News - Article",
            "f.pageType%7CpageType": "News - Press release",
        },
        shouldFacetsFromUrlOverwriteActiveFacets: true,
        onFiltersUpdate: () => {
            const activeFilters = window.searchArticles?.search?.activeFacets;
            for (const entry in activeFilters) {
                if (activeFilters[entry].value !== []) {
                    hasActiveFilters = true;
                    return hasActiveFilters;
                }
            }
        },
        beforeSearch: () => {},
        results: {
            numRanks: 18,
        },
        sort: {
            type: "date",
        },
        activeFacets: {
            target: ".active-facets",
            // ... some other configuration fields
        },
        activeFacetsOnStart: {
            "f.pageType|pageType": [
                //         "expertise - software",
                //         "expertise - sme profile",
                //         "expertise - product",
                //         "expertise - expertise",
                //         "key market"
            ],
            "f.keyMarketEnergy|keyMarketEnergy": [],
            "f.keyMarketEnvironment|keyMarketEnvironment": [],
            "f.geographies|geographies": [],
        },

        pagination: {
            loadMore: true,
        },

        templates: {
            activeFacet: (name, param) => {
                const changeName = name
                    .replace(/_ampersand_/gi, "&")
                    .replace(/_comma_/gi, ",");
                return `
                  <span param="${param}" name="${name}">
                    ${changeName}
                  </span>
                `;
            },
            articleTemplate: (fields) => {
                let pageType = fields.listMetadata.pageType[0]
                    ? fields.listMetadata.pageType[0].replace(/\w*\s-\s/gm, "")
                    : "";
                if (fields.listMetadata.pageType[0] === "News - Article") {
                    pageType = "News article";
                }
                // 2017-08-10 -> 10 Aug 2017
                const changeDate = () => {
                    const monthArray = [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec",
                        ],
                        // dateFromFunnelback = fields.metaData.d, // 2017-08-10
                        splitedDate = fields.listMetadata.d[0].split("-");

                    return `${splitedDate[2]} ${
                        monthArray[Number(splitedDate[1]) - 1]
                    } ${splitedDate[0]}`;
                };
                return `
                        <a href="${
                            fields.liveUrl
                        }" class="cards__card-wrapper cards__card-wrapper">
                            <article class="cards__card row no-gutters flex-column justify-content-between flex-wrap">
                                <div class="cards__flag-wrapper">
                                    <div class="cards__flag-type">
                                    ${pageType}
                                    </div>
                                </div>
                                <div class="cards__date-wrapper">
                                    <div class="cards__publish-date cards__flag-type">${changeDate()}</div>
                                </div>
                                <div class="cards__image-wrapper">
                                    <div class="cards__image"><img src="${
                                        fields.listMetadata.image ||
                                        `https://woodplc.com/?a=235271`
                                    }" alt=""></div>
                                </div>
                               <div class="cards__content no-gutters flex-column justify-content-between">
                                    <p class="cards__type">${pageType}</p>
                                    <div class="cards__title-wrapper">
                                    <p class="cards__title truncate-lines-2">
                                       ${fields.title}
                                    </p>
                                    </div>
                                </div>
                            </article>
                        </a>`;
            },
            /**
             * @name informationTemplate
             * @param fields
             * @param resultsSummary
             * @param h
             * @returns {string}
             **/
            informationTemplate: () => {
                return "";
            },
            formTemplate: (search, query, inputId) => {
                query == "!nullsearch" ? (query = "") : null;
                return `
                <div class="search-field">
                    <form class="search__form" role="search" action="/search" method="get">
                        <label for="${inputId}" class="sr-only">Search site</label>
                        <input
                            id="${inputId}"
                            type="text"
                            class="search__form-input search-custom"
                            placeholder="News search"
                            autocomplete="off"
                            role="searchbox"
                            aria-label="Search"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            maxlength="1000"
                            aria-haspopup="menu"
                            aria-expanded="false"
                            value="${query}">
                        <button type="submit" name="site-search-submit" id="site-search-submit" class="search__submit">
                            <i class="search__submit-icon" aria-hidden="true"></i>
                            <span class="sr-only">Do search</span>
                        </button>
                        <div class="fb-search-wrapper"></div>
                    </form>
                </div>
                `;
            },

            /**
             * @name paginationNumberTemplate
             * @param number
             * @param startrank
             * @returns {string}
             **/

            paginationNumberTemplate: () => {
                return ""; //<li class="hidden" data-startrank=${startrank} tabindex="0" >${number}</li>
            },

            /**
             * @name activePaginationNumberTemplate
             * @param number
             * @returns {string}
             **/

            activePaginationNumberTemplate: () => {
                return ""; //<li class="search__active-page hidden">${number}</li>
            },

            /**
             * @name paginationTemplate
             * @param pages
             * @returns {string}
             **/
            paginationTemplate: (pages) => {
                return `<div class="search__pagination">${pages}</div>`;
            },

            /**
             * @name loadMoreTemplate
             * @param fields
             * @returns {string}
             **/
            loadMoreTemplate: () => {
                return '<div class="landing-page__button-wrapper"><button id="search-loadmore" type="button" title="Load more results" class="btn btn--secondary">Load more</button></div>';
            },

            facetCheckbox: ({ categories, singleChoice }, activeFacets, h) => {
                //{name, label}, activeFacets
                // const header = label ? `<div>${label}</div>` : `<div>${name}</div>`;
                let list = "";
                list +=
                    '<li class="search__facet-item search__facet-item--all"></li>';

                categories[0].values.forEach((item) => {
                    if (item.label !== "other") {
                        list += `<li class="search__facet-item">
                                <label class="search__facet-label">
                                    <input
                                    class="search__facet-input"
                                    type="checkbox"
                                    ${item.checked}
                                    value="${item.data}"
                                    name="${item.label}"
                                    data-fparam="${h.queryStringParamName}"
                                    data-singlechoice="${singleChoice}"
                                    />
                                    <span class="search__facet-span">${item.label}</span>
                                </label>
                                </li>`;
                    }
                });

                return `<div class="checkbox-facet">
                        <ul class="search__facets">
                        ${list}
                        </ul>
                    </div>`;
            },

            /**
             * @name noResults
             * @param query
             * @param spell
             * @returns {string}
             **/
            noResults: () => {
                // let spellSuggestion = "";
                // if (spell.text) {
                //     spellSuggestion = `<div>Did you mean: <a href="?${spell.url}">${spell.text}</a>?</div>`;
                // }
                if (hasActiveFilters) {
                    return `<div>There are no results matching your filter criteria</div>`;
                } else {
                    return `<div>We're sorry, we couldn't find anything matching</div>`;
                }
            },
        },
    });

    window.searchNewsLanding.init();
}
